export const formatCurrency = (price?: number, currency: string = 'USD'): string => {
  if (!price) return '';
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency,
  }).format(price);
};
